import { MantineThemeOverride } from '@mantine/core';

export const mantineThemeColors: MantineThemeOverride['colors'] = {
	// Every shade is populated: v7 derives variant hover/active backgrounds from
	// neighbouring shades (e.g. filled hover = primaryShade+1), so empty slots
	// produce invalid/transparent backgrounds (controls vanish on hover). The
	// previously-empty intermediate shades are filled by linear RGB interpolation
	// between their nearest defined neighbours; originally-defined shades are
	// unchanged.
	gray: [
		'#F4F5F6',
		'#BDC4C8',
		'#E9EBED',
		'#DEE2E4',
		'#D3D8DA',
		'#C8CED1',
		'#BDC4C8',
		'#B2BABF',
		'#A7B0B5',
		'#7B8991',
	],
	dark: [
		'#4F616C',
		'#394E5A',
		'#233A47',
		'#203440',
		'#1C2E39',
		'#192932',
		'#15232B',
		'#1f1f1f',
		'#0E171C',
		'#070C0E',
	],
	red: [
		'#FEE7EA',
		'#FDCFD5',
		'#FBB6C0',
		'#F992A0',
		'#F76E80',
		'#F53E56',
		'#F20D2B',
		'#DA0C27',
		'#C20A23',
		'#49040D',
	],
	pink: [
		'#FFE3F6',
		'#FFC7EC',
		'#FFABE3',
		'#F08FCF',
		'#E072BC',
		'#D156A8',
		'#C23994',
		'#B21D81',
		'#A3006D',
		'#64164A',
	],
	grape: [
		'#F6EDFF',
		'#EDDBFF',
		'#E4C9FF',
		'#D6AEFF',
		'#C892FF',
		'#B66EFF',
		'#A44AFF',
		'#833BCC',
		'#622C99',
		'#210F33',
	],
	violet: [
		'#E3E3FF',
		'#C7C7FF',
		'#ABABFF',
		'#8F8FF0',
		'#7272E0',
		'#5656D1',
		'#3939C2',
		'#1D1DB2',
		'#0000A3',
		'#161664',
	],
	blue: [
		'#E7EFFE',
		'#CFDFFD',
		'#B6CEFB',
		'#92B6F9',
		'#6E9EF7',
		'#3E7EF5',
		'#0D5EF2',
		'#0B4BC2',
		'#083891',
		'#031330',
	],
	cyan: [
		'#c5f6fa',
		'#c5f6fa',
		'#ABEEFF',
		'#8FDCF0',
		'#72CAE0',
		'#56B9D1',
		'#39A7C2',
		'#1D95B2',
		'#0083A3',
		'#165564',
	],
	teal: [
		'#E3FFF6',
		'#C7FFEC',
		'#ABFFE3',
		'#8FF0CF',
		'#72E0BC',
		'#56D1A8',
		'#39C294',
		'#1DB281',
		'#00A36D',
		'#16644A',
	],
	green: [
		'#E7FEEA',
		'#CFFDD5',
		'#B6FBC0',
		'#92F9A0',
		'#6EF780',
		'#3EF556',
		'#0DF22B',
		'#0CDA27',
		'#0AC223',
		'#04490D',
	],
	lime: [
		'#F1F9D2',
		'#EEF8C7',
		'#EBF6BB',
		'#E1F299',
		'#D6EE77',
		'#CFEB5F',
		'#C7E747',
		'#9CB72D',
		'#708712',
		'#252D06',
	],
	yellow: [
		'#FFFDE3',
		'#FFFBC7',
		'#FFF9AB',
		'#F0E98F',
		'#E0D972',
		'#D1C956',
		'#C2B839',
		'#B2A81D',
		'#A39800',
		'#645F16',
	],
	orange: [
		'#FEF3E7',
		'#FDE7CF',
		'#FBDBB6',
		'#F9C992',
		'#F7B76E',
		'#B8670A',
		'#F2870D',
		'#794406',
		'#C26C0A',
		'#492904',
	],

	// v7 requires every color to be a 10-shade tuple (MantineColorsTuple);
	// white/black are intentionally flat, so every shade repeats the single value.
	white: [
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
		'#FFFFFF',
	],
	black: [
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
		'#000000',
	],
};
